module.exports = __webpack_public_path__ + "img/nature-42.46c8e721.jpg";